import {
  Image,
  Text,
  YStack,
  YStackProps,
} from '@bounty/creators-design-system'

export type ProductCardProps = YStackProps & {
  onImageError?: () => void
  product: {
    imgLink: string | null
    productName: string
  }
}

export const ProductCard = ({
  product,
  onImageError,
  ...props
}: ProductCardProps) => {
  return (
    <YStack data-testid="productCard" cursor={'pointer'} {...props}>
      <YStack
        justifyContent="flex-end"
        p="$2"
        position="relative"
        overflow="hidden"
        height={160}
        $gtSm={{
          height: 172,
        }}
      >
        {/*
        // @ts-expect-error - Internal types wrong. Do not need height or width when absolute*/}
        <Image
          position="absolute"
          top={0}
          bottom={0}
          // TODO: See if this is working on native
          onError={onImageError}
          left={0}
          right={0}
          resizeMode="contain"
          src={product.imgLink!}
          alt={product.productName}
        />
      </YStack>
      <YStack width={172}>
        <Text
          size="$xs"
          color="$neutral.600"
          fontWeight={'$semibold'}
          pr="$1"
          flexShrink={1}
          numberOfLines={1}
        >
          {product.productName}
        </Text>
      </YStack>
    </YStack>
  )
}
